import { stringify } from 'querystring';
import React from 'react';
import styled, { css } from 'styled-components';
import { getIn } from 'seamless-immutable';
import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';
import { withMetrics } from '@catalogo/core-metrics';

class Sku extends React.Component {
  conditionType = 'condition';

  componentDidUpdate(prevProps) {
    const { currentSku: prevCurrentSku } = prevProps;
    const { currentSku, dispatchMetrics } = this.props;

    if (prevCurrentSku.id !== currentSku.id) {
      dispatchMetrics('sku:selected', currentSku);
    }
  }
  hasOffers(value) {
    return !!getIn(value, ['offers', 'result'], []).length;
  }

  fmtLabelText(text) {
    const options = {
      NEW: 'novo',
      REWRAPPED: 'reembalado',
      USED: 'usado',
    };

    return options[text] ?? text;
  }

  getDiffs(diffs) {
    return diffs ? diffs.reduce((tps, diff) => ({ ...tps, [diff.type.toLowerCase()]: diff.value }), {}) : {};
  }

  getSkus() {
    const { product } = this.props;
    return getIn(product, ['skus'], []);
  }

  getSku(type, value) {
    const { currentSku } = this.props;
    const skus = this.getSkus();
    const types = Object.keys(currentSku.qs || {}) || [];
    const typesCondition = types.includes(this.conditionType) ? types.length > 2 : types.length > 1;

    if (typesCondition) {
      return skus.find(sku => {
        const diffs = this.getDiffs(sku.diffs);
        return diffs[type] === value && Object.keys(diffs).find(tp => type !== tp && diffs[tp] === currentSku.qs[tp]);
      });
    }
    return skus.find(sku => getIn(sku, ['diffs', '0', 'value'], '') === value);
  }

  getConditions() {
    const skus = this.getSkus();
    const conditions = skus?.reduce(
      (listConditions, { offers }) =>
        offers && (listConditions ?? []).concat(offers.result?.map(({ condition }) => condition)),
      []
    );

    return Array.from(new Set(conditions));
  }

  setSelectedOption(type, value) {
    const { parsedQs, history } = this.props;
    const newQueryString = {
      ...parsedQs,
      [type]: value,
    };

    history.replace(`?${stringify(newQueryString)}`);
  }

  renderLabel(type, description) {
    const { product, currentSku, parsedQs } = this.props;
    const hasOffer = this.hasOffers(product);
    const typeDescription = description || type;
    const typeValue = this.fmtLabelText(parsedQs[type]);

    if (hasOffer || Object.keys(parsedQs).length) {
      return (
        <Label hasOffer={!currentSku || this.hasOffers(currentSku)}>
          {!currentSku || this.hasOffers(currentSku) ? (
            <>
              {typeDescription}: <Bold>{typeValue}</Bold>
            </>
          ) : (
            <>
              {typeDescription} {typeValue} indisponível
            </>
          )}
        </Label>
      );
    }

    return (
      <Label hasOffer={true}>
        {type}: <Bold>-</Bold>
      </Label>
    );
  }

  renderOption(type, item) {
    const { parsedQs } = this.props;
    const skuSelected = this.getSku(type, item.value);
    const image = getImage(getIn(item, ['images', '0']), 'small');

    return (
      <Item
        key={`${type}-${getIn(item, ['value'], '').replace(' ', '-')}`}
        onClick={() => this.setSelectedOption(type, getIn(item, ['value'], ''))}
        selected={parsedQs[type] === item.value}
        hasOffer={this.hasOffers(skuSelected)}
      >
        <ItemValues>
          {getIn(item, ['images'], null) !== null && <Image src={image} />}
          <Text hasImage={getIn(item, ['images'], null) !== null}>{getIn(item, ['value'], '')}</Text>
        </ItemValues>
      </Item>
    );
  }

  renderConditions() {
    const conditions = this.getConditions();

    if (!conditions?.length || (conditions?.length === 1 && conditions[0].toLowerCase() === 'new')) {
      return null;
    }

    const { parsedQs } = this.props;

    return (
      <Type>
        <SelectedOption>{this.renderLabel(this.conditionType, 'condição')}</SelectedOption>
        {conditions?.length > 1 &&
          conditions?.map(condition => (
            <Item
              key={condition}
              onClick={() => this.setSelectedOption(this.conditionType, condition)}
              selected={parsedQs[this.conditionType] === condition}
              hasOffer={true}
            >
              <ItemValues>
                <Text>{this.fmtLabelText(condition)}</Text>
              </ItemValues>
            </Item>
          ))}
      </Type>
    );
  }

  render() {
    const { product } = this.props;

    if (getIn(product, ['diffs'], null) === null) {
      return null;
    }
    return (
      <>
        {product?.diffs?.length > 0 && this.renderConditions()}
        {getIn(product, ['diffs'], []).map(diff => {
          const type = getIn(diff, ['type'], '').toLowerCase();
          const currentType = getIn(product, ['diffs'], []).find(diff => diff.type.toLowerCase() === type);
          return (
            <Type key={type}>
              <SelectedOption>{this.renderLabel(type)}</SelectedOption>
              {getIn(currentType, ['values'], []).length > 1 && (
                <WrappOptions>
                  <Options>
                    {getIn(diff, ['values'], []).map((item, index) => this.renderOption(type, item, index))}
                  </Options>
                </WrappOptions>
              )}
            </Type>
          );
        })}
      </>
    );
  }
}

export default withMetrics(Sku);

const SelectedOption = styled.div`
  text-align: left;
  line-height: normal;
  padding-bottom: 10px;
  color: #666;
  margin: 0px;
  padding-bottom: 10px;
  font-size: 14px;
`;

const Label = styled.label`
  ${({ hasOffer }) =>
    !hasOffer &&
    css`
      color: #f00;
    `}
`;

const Image = styled.img`
  width: 100%;
  height: auto;

  align-self: center;
  max-width: 100%;
  width: 100%;
  opacity: 1;
  flex: 0 0 auto;
  animation: 120ms linear 0s 1 normal none running animateImage;

  width: 45px;
  height: 45px;
  margin: 0px 8px;

  @keyframes animateImage {
    0% {
      opacity: 0;
      transform: scale(0.7);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const Bold = styled.strong`
  font-weight: bold;
  line-height: 16px;
`;

const WrappOptions = styled.div`
  display: flex;
  min-height: 1px;
  flex-direction: column;
`;

const Options = styled.div`
  text-align: left;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  white-space: nowrap;
  display: block;
  overflow: auto;

  @media (min-width: 769px) {
    white-space: normal;
  }
`;

const Type = styled.div`
  max-width: 100%;
  margin-bottom: 0px;
  margin-top: 20px;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
  padding: 20px 0 0 0;
  text-transform: lowercase;
`;

const Item = styled.button`
  position: relative;
  cursor: pointer;
  border: 1px solid #e2e3e3;
  background-color: transparent;
  max-width: 77px;
  max-height: 83px;

  min-width: 40px;
  padding: 10px 8px;
  overflow: hidden;
  border-radius: 4px;
  margin-right: 6px;
  margin-bottom: 6px;

  ${({ selected }) =>
    selected &&
    css`
      border-color: #000;
    `}
  &:focus {
    outline: 0;
  }

  ${({ hasOffer }) =>
    !hasOffer &&
    css`
      opacity: 0.4;
    `}
`;

const ItemValues = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Text = styled.span`
  display: inline-block;
  color: #666;
  font-size: 14px;

  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  text-align: center;
  align-items: center;
  max-width: 60px;

  ${({ hasImage }) =>
    hasImage &&
    css`
      font-size: 11px;
      margin-top: 5px;
      text-transform: lowercase;
      &::first-letter {
        text-transform: uppercase;
      }
    `}
`;
